export default "__VITE_ASSET__Cnb_8wUW__"